interface RawPost {
  type: string
  slug: string
  acf: {
    'data-permalink': string
  }
}

export const getPostSlug = (rawPost: RawPost): string => {
  switch (rawPost.type) {
    case 'post':
    case 'producttest':
    case 'guides':
    case 'sw_category':
    case 'product':
      return rawPost.slug
    case 'page':
      return rawPost.acf['data-permalink']
    default:
      throw new Error(`Cannot find rawPost slug for type "${rawPost.type}"`)
  }
}
